<template>
  <v-card outlined class="operation-panel" :class="panelClass">
    <v-card-title class="operation-panel__title pa-0">
      <div>
        <div class="operation-panel__heading">{{ title }}</div>
        <div v-if="subtitle" class="operation-panel__subtitle">
          {{ subtitle }}
        </div>
      </div>
      <div v-if="$slots.meta || chipLabel" class="operation-panel__meta">
        <slot name="meta">
          <v-chip small outlined :color="chipColor">{{ chipLabel }}</v-chip>
        </slot>
      </div>
    </v-card-title>
    <v-card-text class="operation-panel__body pa-0">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "OperationPanel",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    tone: {
      type: String,
      default: "default",
    },
    chipLabel: {
      type: String,
      default: null,
    },
    chipColor: {
      type: String,
      default: "primary",
    },
  },
  computed: {
    panelClass() {
      return {
        "operation-panel--primary": this.tone === "primary",
        "operation-panel--warning": this.tone === "warning",
        "operation-panel--success": this.tone === "success",
      };
    },
  },
};
</script>

<style scoped>
.operation-panel {
  margin-bottom: 16px;
  padding: 22px 24px;
}

.operation-panel.v-sheet.operation-panel--primary {
  background-color: #f4f6ff !important;
  border-color: rgba(88, 103, 221, 0.36) !important;
}

.operation-panel.v-sheet.operation-panel--warning {
  background-color: #fff8e6 !important;
  border-color: rgba(255, 168, 0, 0.42) !important;
}

.operation-panel.v-sheet.operation-panel--success {
  background-color: #e8faf9 !important;
  border-color: rgba(27, 197, 189, 0.42) !important;
}

.operation-panel__title {
  align-items: start;
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1fr) auto;
  margin-bottom: 18px;
}

.operation-panel__heading {
  color: #212121;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.35;
}

.operation-panel__subtitle {
  color: #757575;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.45;
  margin-top: 7px;
}

.operation-panel__meta {
  justify-self: end;
  padding-top: 2px;
}

.operation-panel__body {
  color: #2b2b2b;
}

@media (max-width: 600px) {
  .operation-panel__title {
    grid-template-columns: 1fr;
  }

  .operation-panel__meta {
    justify-self: start;
  }
}
</style>
